import { Card, GridItem, SimpleGrid } from '@chakra-ui/react';
import { useTranslate } from '@tolgee/react';
import { DateRange } from '../../common/reservation-analytic-service';
import AppointmentHourDistributionReport from './appointment-hour-distribution-report';

export default function AppointmentChartLayout({ dateRange }: { dateRange: DateRange }) {
  const { t } = useTranslate();
  return (
    <Card.Root>
      <Card.Header>
        <Card.Title fontWeight={'semibold'} fontSize={'xl'}>
          {t('appointment.chart.header', 'Chart')}
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <SimpleGrid columns={{ base: 1, sm: 2 }} gapX={16} gapY={6} w={'full'}>
          <GridItem>
            <AppointmentHourDistributionReport startTime={dateRange.startDate} endTime={dateRange.endDate} />
          </GridItem>
        </SimpleGrid>
      </Card.Body>
    </Card.Root>
  );
}
